module.exports = __webpack_public_path__ + "static/media/event-6.eb7c08c2.JPG";